import { render, staticRenderFns } from "./xxjlDialog.vue?vue&type=template&id=c7afb6fc&scoped=true&"
import script from "./xxjlDialog.vue?vue&type=script&lang=js&"
export * from "./xxjlDialog.vue?vue&type=script&lang=js&"
import style0 from "./xxjlDialog.vue?vue&type=style&index=0&id=c7afb6fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7afb6fc",
  null
  
)

export default component.exports